import { authConstants } from '../constants'
import { persistence } from '../persistence'
import { getDataModules } from '../../utils'

export const Authentication = (state = {}, action) => {
  switch (action.type) {
    case authConstants.AUTH_REQUEST:
      return { loading: true, items: undefined, error: undefined }//Mostrar gif loader mientras ejecuta request

    case authConstants.AUTH_SUCCESS:
      const userData = {
        userId: action.authenticationData.Body.UserLoginData.Id,
        userName: action.authenticationData.Body.UserLoginData.Username,
        name: action.authenticationData.Body.UserLoginData.Name,
        lastName: action.authenticationData.Body.UserLoginData.FatherLastName,
        surName: action.authenticationData.Body.UserLoginData.MotherLastName,
        email: action.authenticationData.Body.UserLoginData.Email,
        phone: action.authenticationData.Body.UserLoginData.PhoneNumber,
        token: action.authenticationData.Body.Token,
        roleName: action.authenticationData.Body.UserLoginData.SecurityLoginData.Roles[0].Name
      }
      persistence.SaveUser(userData).then(res => {
        console.log("Datos almacenados correctamente")
      }).catch(err => {
        console.log("El usuario ya existe en la base de datos")
      })//Almacenar datos de usuario en persistencia local
      if (action.authenticationData.Body.UserLoginData?.SecurityLoginData?.Roles.filter(item => item.Name == "Usuario Autoconsumo")?.length > 0) {
        localStorage.setItem("IsAutoconsumo", true)
      } else if (action.authenticationData.Body.UserLoginData?.SecurityLoginData?.Roles[0]?.Name == "Agente") {
        localStorage.setItem("IsAutoconsumo", false)
      }

      return {
        loading: false,
        items: action.authenticationData.Body,//Obtener respuesta correcta del API
        roles: action.authenticationData?.roles || [], //multiples usuarios obtenidos
        dataModules: getDataModules(action.authenticationData.Body),//Obtener permisos de modulos
        error: undefined
      }
    case authConstants.AUTH_UPDATED:
      return {
        loading: false,
        items: action.authData,//Obtener respuesta correcta del API        
        dataModules: getDataModules(action.authData),//Obtener permisos de modulos
        error: undefined
      }
    case authConstants.AUTH_FAILURE:
      return {
        loading: false,
        items: undefined,
        error: action.error//Mostrar error del API
      }
    default:
      return state//Retornar state vacío o actual
  }
}
//Siguiente paso => Volver a screens con respuesta

export const GetClientIPsWithRefer = (state = {}, action) => {
  switch (action.type) {
    case authConstants.CLIENTIPS_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case authConstants.CLIENTIPS_SUCCESS:
      return {
        loading: false,
        items: action.clientIPs.Body,
        error: undefined
      }

    case authConstants.CLIENTIPS_FAILURE:
      return { loading: false, items: undefined, error: action.error }

    default:
      return state
  }
}
